export {default} from './Layout';



// WEBPACK FOOTER //
// ./src/components/GlobalLayout/Layout/index.ts